
import axiosApi from '@/request/index'
import Icon from 'vux/src/components/icon/index.vue'

import Scroll from 'vue-slim-better-scroll'
import QuicklyNav from '@/components/quicklyNav'
import HeadNav from '@/components/headNav'
import { Dialog } from 'vant';

export default {
name: "List",
components: {
Icon,
Scroll,
QuicklyNav,
HeadNav
},
data() {
return {
query: {
size: 10,
start: 0,
sortType: 1,
searchText: '',
classId: '',
brandIdList: [],
selectedBrand: "", //被选中品牌
selectedSize:"",//选择尺寸
minPrice:'',
maxPrice:'',
brandIdList:[],
goodsSpec:[],
},
list: [],
lastY: 0,
totalSize: 0,
isLoading: false,
title: '',
imgUrl: HTTP_IMG_URL,
modalShow : false,
brandList:[],
minPrice:'',
maxPrice:'',
sizeList:[],
isSearch:true
}
},
beforeRouteEnter(to, from, next) {
let lastY = 0;
if (from.name == 'shop') {
lastY = localStorage.getItem('scrollY') || 0;
}
next(vm => {
if (from.name != 'shop') {
vm.query.sortType = 1;
let query = vm.$route.query;
let classId = query.classId || '';
let brandId = query.brandId || '';
let title = query.title || '顶呱呱新零售';
vm.title = title
vm.query.searchText = vm.$route.params.searchContent || ''
vm.query.classId = classId;
vm.query.brandIdList = brandId ? [brandId + ''] : [];
document.title = title;
vm.loadRefresh();
vm.getBrandList()
vm.getSizeList()
}
vm.lastY = lastY;
vm.$refs.scroll.scrollTo(0, lastY, 0)
});
},
beforeRouteLeave(to, from, next) {
if (to.name == 'shop') {
localStorage.setItem('scrollY', this.lastY);
} else {

}
next(vm => {
if (to.name != 'shop') {
vm.list = [];
}
});
},
created() {
},
mounted() {
},
methods: {

goTop() {
this.$refs.scroll.scrollTo(0, 0, 500)
},

updateType(index) {
let selectIndex = index;
let sortType = this.query.sortType;
if (selectIndex >= 3) {
if (sortType == 4) {
selectIndex = 3;
} else {
selectIndex = 4;
}
}
this.query.sortType = selectIndex;
this.list = [];
this.loadRefresh();
},

searchHandler() {
this.$refs.scroll.scrollTo(0, 0, 0)
this.list = [];
this.loadRefresh();
},

showModal() {
this.modalShow = true
},
closeModal() {
this.modalShow = false
},
getScroll(e) {
this.lastY = e.y;
},

getBrandList:function(){
var param = {
};
axiosApi.getBrandSort(param).then(res => {
if (res.code == 0) {
this.brandList = res.content
}
});
},

getSizeList: function () {
var param = {
optionId:"system.goodsSpec"
};
axiosApi.getSizeList(param).then(res => {
if (res.code == 0) {
console.log(res)
this.sizeList = res.content
}
});
},

selectBrand(index){
this.$set(this.brandList[index],'selectedBrand',this.brandList[index].selectedBrand?false:true)
},

selectSize(index){
this.$set(this.sizeList[index],'selectedSize',this.sizeList[index].selectedSize?false:true)
},
resetClick:function(e){
for(var i=0;i<this.brandList.length;i++){
this.$set(this.brandList[i],'selectedBrand',false)
}
for (var i = 0; i < this.sizeList.length; i++) {
this.$set(this.sizeList[i],'selectedSize',false)
}
this.query.minPrice='';
this.query.maxPrice='';
},
confirmClick(){
this.query.brandIdList = [];
this.query.goodsSpec = [];
for (var i = 0; i < this.brandList.length; i++) {
if (this.brandList[i].selectedBrand) {
this.query.brandIdList.push(this.brandList[i].brandId);
}
}
for (var i = 0; i < this.sizeList.length; i++) {
if (this.sizeList[i].selectedSize) {
this.query.goodsSpec.push(this.sizeList[i].code);
}
}
this.isSearch = false,
this.list =[];
this.query.start = 0;
this.isSearch = false

this.loadRefresh();

this.closeModal();
},

async loadRefresh() {
if(this.isSearch){
this.query.goodsSpec = []
this.query.brandIdList = []
this.query.minPrice = ''
this.query.maxPrice = ''
this.resetClick()
}
this.isLoading = true;
this.query.start = 0;
const data = await this._fetchList()

this.list = data
this.isLoading = false;
},

async loadMore() {
this.isLoading = true;
this.query.start += this.query.size
const data = await this._fetchList()
this.list.push(...data)
this.isLoading = false;
this.list.length >= this.totalSize ? this.$refs.scroll.update(true) : null 
},

async _fetchList() {
let query = this.query;
let getData = await axiosApi.getClassGoods(query).then(res => {
if (res.code == 0) {
let data = res.content;
this.totalSize = data.total;
return data.list || [];
}
});
return getData;
}
}

}



// WEBPACK FOOTER //
// ./src/pages/list/index.vue